/* Salty Paws - persistent add-to-cart confirmation. Aug 19 2026.
   In-flow markup only: no fixed or sticky positioning, no overlay, no timer.
   Reads the real cart via /cart.js so it can never show a false success.
   Oct 18 2026: the Checkout link is styled as a full width green button
   (#124E2F, same green as the cart page Checkout button). CSS only.
   Oct 22 2026: the box used to appear only right after Add to cart, so a
   shopper who went to checkout and pressed Back saw no box and no way back to
   the cart (Linda, Android via Messenger). Now, on a product page, it is drawn
   again on every load, Back/Forward and return to the tab whenever the cart
   has items: "Added to your cart: <this product>" when this product is in the
   cart, otherwise "Your cart has N items." Same Checkout / View cart links.
   Empty cart: no box. To revert: restore BACKUP_sp-cart-confirm.v1_2026-10-22.js
   from WEBSITE\theme-backups. */
(function () {
  'use strict';

  var STYLE_ID = 'sp-added-style';
  var CSS =
    '.sp-added{margin:12px 0 0;padding:12px 14px;border:1px solid currentColor;border-radius:8px;font-size:.95rem;line-height:1.45}' +
    '.sp-added__line{margin:0 0 8px}' +
    '.sp-added__links{display:flex;flex-wrap:wrap;gap:10px 14px;align-items:center;justify-content:center}' +
    '.sp-added__cta{flex:1 1 100%;display:flex;align-items:center;justify-content:center;min-height:48px;padding:12px 16px;border-radius:12px;background:#124E2F;color:#fff !important;font-weight:700;text-transform:uppercase;letter-spacing:.02em;text-decoration:none !important}' +
    '.sp-added__cta:hover{background:#0D3620}';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Accepts a bare id or a gid://shopify/Product/123 and returns the digits. */
  function idOf(v) {
    var m = String(v == null ? '' : v).match(/(\d+)\s*$/);
    return m ? m[1] : '';
  }

  /* /cart.js returns the most recently added line FIRST, so never use the last
     entry. Prefer the line matching the product the shopper just added. */
  function addedItem(cart, productId) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var want = idOf(productId);
    if (want) {
      for (var i = 0; i < cart.items.length; i++) {
        if (idOf(cart.items[i].product_id) === want) return cart.items[i];
      }
    }
    return cart.items[0];
  }

  function slot(form) {
    var el = form.querySelector('.sp-added');
    if (el) return el;
    var anchor =
      form.querySelector('[ref="acceleratedCheckoutButtonContainer"]') ||
      form.querySelector('[ref="addToCartButtonContainer"]') ||
      form.querySelector('add-to-cart-component');
    if (!anchor || !anchor.parentNode) return null;
    el = document.createElement('div');
    el.className = 'sp-added';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    return el;
  }

  function render(form, cart, productId) {
    var el = slot(form);
    if (!el) return;

    var item = addedItem(cart, productId);
    if (!item) {
      el.innerHTML =
        '<p class="sp-added__line"><strong>Your cart did not save in this browser.</strong></p>' +
        '<div class="sp-added__links">Please tap Add to cart again, or open saltypaws.shop in Safari or Chrome.</div>';
      return;
    }

    var title = esc(item.product_title || 'Your item');
    var variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? ' — ' + esc(item.variant_title)
        : '';
    var n = cart.item_count;

    el.innerHTML =
      '<p class="sp-added__line"><strong>Added to your cart:</strong> ' + title + variant + '</p>' +
      '<div class="sp-added__links">' +
      '<a class="sp-added__cta" href="/checkout">Checkout (' + n + ' item' + (n === 1 ? '' : 's') + ') →</a>' +
      '<a href="/cart">View cart</a>' +
      '</div>';
  }

  function update(form, productId) {
    injectStyle();
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(form, cart, productId);
        setTimeout(function () { render(form, cart, productId); }, 900);
      })
      .catch(function () { render(form, null, productId); });
  }

  document.addEventListener('cart:update', function (event) {
    var node = event.target;
    var form =
      node && typeof node.closest === 'function'
        ? node.closest('product-form-component')
        : null;
    if (!form) form = document.querySelector('product-form-component');
    if (!form) return;
    var detail = event.detail || {};
    var data = detail.data || {};
    update(form, data.productId);
  });

  /* ---- Oct 22 2026: bring the box back whenever the cart has items ---- */

  /* The page's own product form (never the quick add dialog), product pages only. */
  function pageForm() {
    if (!/\/products\//.test(location.pathname)) return null;
    var forms = document.querySelectorAll('product-form-component');
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].closest('dialog')) return forms[i];
    }
    return null;
  }

  var pageIdReady = null;
  function pageProductId() {
    if (pageIdReady) return pageIdReady;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    pageIdReady = !m
      ? Promise.resolve('')
      : fetch('/products/' + m[1] + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) { return p && p.id ? String(p.id) : ''; })
          .catch(function () { return ''; });
    return pageIdReady;
  }

  function inCart(cart, productId) {
    var want = idOf(productId);
    if (!want || !cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (idOf(cart.items[i].product_id) === want) return true;
    }
    return false;
  }

  function renderSummary(form, cart) {
    var el = slot(form);
    if (!el) return;
    var n = cart.item_count;
    el.innerHTML =
      '<p class="sp-added__line"><strong>Your cart has ' + n + ' item' + (n === 1 ? '' : 's') + '.</strong></p>' +
      '<div class="sp-added__links">' +
      '<a class="sp-added__cta" href="/checkout">Checkout (' + n + ' item' + (n === 1 ? '' : 's') + ') →</a>' +
      '<a href="/cart">View cart</a>' +
      '</div>';
  }

  function restore() {
    var form = pageForm();
    if (!form) return;
    Promise.all([
      pageProductId(),
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
    ])
      .then(function (res) {
        var id = res[0];
        var cart = res[1];
        if (!cart || !cart.item_count) {
          var old = form.querySelector('.sp-added');
          if (old) old.parentNode.removeChild(old);
          return;
        }
        injectStyle();
        if (inCart(cart, id)) render(form, cart, id);
        else renderSummary(form, cart);
      })
      .catch(function () { /* leave the page as it is */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) restore(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') restore();
  });
})();
